"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableContainer = TableContainer;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function TableContainer(_ref) {
  var children = _ref.children,
      maxHeight = _ref.maxHeight,
      minWidth = _ref.minWidth,
      style = _ref.style,
      tableActions = _ref.tableActions,
      tableData = _ref.tableData,
      loading = _ref.loading;

  var clonedChildren = _react["default"].Children.toArray(children).map(function (child) {
    return /*#__PURE__*/_react["default"].cloneElement(child, {
      tableActions: tableActions,
      tableData: tableData,
      loading: loading
    });
  });

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "SmartTable_tableBody",
    id: "smartTable",
    style: {
      maxHeight: maxHeight
    }
  }, /*#__PURE__*/_react["default"].createElement("table", {
    className: "SmartTable_table",
    style: _objectSpread({
      minWidth: minWidth
    }, style)
  }, clonedChildren));
}

TableContainer.propTypes = {
  maxHeight: _propTypes["default"].string,
  minWidth: _propTypes["default"].string,
  style: _propTypes["default"].object,
  tableActions: _propTypes["default"].object,
  tableData: _propTypes["default"].object,
  loading: _propTypes["default"].bool
};
TableContainer.defaultProps = {
  minWidth: '950px',
  maxHeight: '560px'
};
var _default = TableContainer;
exports["default"] = _default;